import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  leftContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  dropDownWidth: {
    width: theme.spacing(29.625),
  },
  rightContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
  },
  filterSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  filtersAppliedContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    width: '100%',
    gap: theme.spacing(2),
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  selectedFilter: {
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(-2),
  },
  renewButton: {
    height: theme.spacing(5.5),
  },
  aboBtn: {
    width: '100%',
  },
  permissionLink: {
    color: `var(--M3-light-primary, ${theme.palette.primary.main})`,
    fontWeight: 500,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}))
